export default __webpack_public_path__ + "static/media/warning--two-way-traffic--g6.444c4349.png";